import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';

export class RestoreWindow {
  static open(bodyContent: HTMLElement, translateFn: Function, containerRef: HTMLElement): GzDialogWebComponent {
    const windowConfigs: GzDialog = {
      headline: translateFn('Restore'),
      bodyContent,
      isOpen: true,
      isWindow: true,
    };

    return GzDialogWebComponent.buildDialogElement(windowConfigs, containerRef);
  }
}
